import { PropsWithChildren, ReactNode } from 'react';

import type { DetailCardTone } from './types';

import { cn } from '@/lib/utils';

import {
  DETAIL_CARD_ICON_CLASS_NAME,
  DETAIL_CARD_ICON_TONE_CLASS_NAMES,
} from './consts';

type DetailCardIconProps = PropsWithChildren<{
  tone?: DetailCardTone;
  label?: ReactNode;
}>;

export const DetailCardIcon = (props: DetailCardIconProps) => {
  const { tone, label, children } = props;

  if (!tone) {
    return (
      <span className={cn(DETAIL_CARD_ICON_CLASS_NAME, !!label && 'gap-1.5')}>
        {children}
        {label}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'flex h-6 shrink-0 items-center justify-center rounded-md [&>svg]:size-3.5',
        label ? 'gap-1.5 px-2 text-xs font-medium' : 'w-6',
        DETAIL_CARD_ICON_TONE_CLASS_NAMES[tone],
      )}
    >
      {children}
      {label}
    </span>
  );
};
